import React from 'react'
import { formatDate } from '@/lib/utils'
import { useTranslation } from '@/hooks/useTranslation'
import styles from './PostMeta.module.scss'

interface PostMetaProps {
  author?: string | null
  publishedAt: string | null
  readingMinutes?: number
}

export const PostMeta: React.FC<PostMetaProps> = ({ author, publishedAt, readingMinutes }) => {
  const { t, locale } = useTranslation()
  const parts = [
    author,
    publishedAt && formatDate(publishedAt, locale),
    readingMinutes && `${readingMinutes} ${t('blog.min_read')}`,
  ].filter(Boolean)

  return (
    <div className={styles.meta}>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className={styles.separator} aria-hidden="true">/</span>}
          <span>{part}</span>
        </React.Fragment>
      ))}
    </div>
  )
}
